<template>
    <select
        :value="value"
        class="kgr-select"
        @change="update()"
    >
        <option
            :value="null"
            class="kgr-select__option"
        >
            {{ $t('pleaseChooseAnOption') }}
        </option>
        <option
            value="name"
            class="kgr-select__option"
        >
            {{ $t('department.name') }}
        </option>
    </select>
</template>

<script>
export default {
    name: 'kgr-department-sort-select',
    props: {
        value: {
            type: String,
            required: false,
        },
    },

    methods: {
        update() {
            const value = this.$el.value;
            const selection = value === '' ? null : value;
            this.$emit('input', selection);
            this.$nextTick(() => {
                this.$emit('post-input', selection);
            });
        },
    },
};
</script>
